import { Component, Vue } from "vue-property-decorator";

@Component
export default class IBDialogFieldFocusing extends Vue {

	readonly transitionDuration: number = 350

	focusFieldAfterTransition(
		focusAction: () => void
	) {
		setTimeout(
			() => focusAction(),
			this.transitionDuration * 2
		);
	}

}